import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ArcDto, UserDto } from 'booksprout'
import { BaseModelDto } from '../../base/baseModel.dto'
import { ownerOrStaffOnly } from '../../base/ownerOrStaffOnly.middleware'
import { ArcReviewDto } from '../review'

@ObjectType()
export class ArcClaimDto extends BaseModelDto {
  @Field(type => ArcDto, { nullable: true })
  arc?: ArcDto

  @Field(t => Int)
  status!: number

  @Field()
  state!: number

  @Field()
  statusDate!: Date

  @Field(t => Int, { nullable: true })
  cancellationType?: number

  @Field({ nullable: true })
  cancellationReason?: string

  // The models below are set based on the ARC this claim is for

  @Field(type => Int, { defaultValue: 0 })
  reviewFlags!: number

  @Field(type => Int, { defaultValue: 0, nullable: true })
  optionalReviewFlags?: number

  @Field(type => Int, { nullable: true })
  requiredReviewCount?: number

  @Field({ nullable: true })
  stopDownloadDate?: Date

  @Field(type => Int, { defaultValue: 0 })
  reviewDays: number = 0

  @Field(t => ArcReviewDto, { nullable: true })
  review?: ArcReviewDto

  @Field(t => Int)
  reviewId?: number

  @Field(t => Int, { defaultValue: 0 })
  vipExclusiveAccessDays: number = 0

  @Field()
  dueDate!: Date

  @Field(t => UserDto, { nullable: true })
  user?: UserDto

  @Field({ nullable: true })
  additionalInformation?: string

  @Field({ nullable: true })
  downloadCode?: string

  /**
   * Expiry of the Apple Books code above, so the reader can be shown Apple's terms before they
   * redeem it (sc-28048). A calendar day as `YYYY-MM-DD`, not an instant - see
   * BookAppleBooksCodeDto. Null for other stores' codes and for Apple codes added before we
   * started asking authors for a date.
   */
  @Field({ nullable: true })
  downloadCodeExpirationDate?: string

  /**
   * The book's Smashwords coupon, for the claim's own reader. It used to be read off `arc.book`, which also
   * handed it to anyone who opened the campaign; the book's copy is now kept to its owner and staff, and a
   * claimant gets it here, on the one query that returns their own claim (`arcUserClaim`). Guarded as well,
   * the claim's owner being the reader who made it [sc-28919].
   */
  @Field({ nullable: true, middleware: [ownerOrStaffOnly] })
  smashwordsCouponCode?: string

  /**
   * The book's master files, for the claim's own reader to read in the app. The book's paths are only sent to its
   * owner and staff now, so a claimant gets them here instead - guarded the same way [sc-28919].
   */
  @Field({ nullable: true, middleware: [ownerOrStaffOnly] })
  epubFile?: string

  @Field({ nullable: true, middleware: [ownerOrStaffOnly] })
  pdfFile?: string

  @Field(t => Int, { nullable: true })
  selectedAudioSiteFlag?: number

  @Field(t => Boolean, { nullable: true })
  authorOwnsArc?: boolean

  @Field({ nullable: true })
  lastReadCfi?: string

  @Field(t => Int, { nullable: true })
  overdueDays?: number

  @Field(t => Boolean, { nullable: true })
  canFollowTeam?: boolean

  @Field(t => Int, { nullable: true })
  reviewerStatus?: number
}
